import React from "react";
import { useSelector } from "react-redux";
import { calculator, getActivePrice } from "../../../../utils/helper";

export default function Table() {
  const { cart } = useSelector((state) => state);
  const dataToDisplay = cart?.selected?.data;
  return (
    <>
      <table className="display table-hover w-full">
        <thead>
          <tr className="bg-gray-100 w-full">
            <td className="font-bold text-gray-900">Name</td>
            <td className="font-bold text-gray-900">Quantity</td>
            <td className="font-bold text-gray-900">Price(RWF)</td>
            <td className="font-bold text-gray-900">Amount (RWF)</td>
          </tr>
        </thead>
        <React.Fragment>
          <tbody className="">
            {dataToDisplay?.products?.length > 0 && (
              <>
                {dataToDisplay?.products?.map((d) => (
                  <tr className="h-10 w-full">
                    <td className="text-gray-900">
                      {d.productId?.productname}
                    </td>
                    <td className="text-gray-900">{d.quantity}</td>
                    <td className="text-gray-900">
                      {parseInt(d?.productId?.amount)?.toLocaleString()}
                    </td>
                    <td className="text-gray-900">
                      {(
                        d.quantity * parseInt(d?.productId?.amount)
                      )?.toLocaleString()}
                    </td>
                  </tr>
                ))}
              </>
            )}
            {dataToDisplay?.listOfService?.length > 0 && (
              <>
                {dataToDisplay?.listOfService?.map((d) => (
                  <tr className="h-10 w-full">
                    <td className="text-gray-900">{d.servicename}</td>
                    <td className="text-gray-900">-</td>
                    <td className="text-gray-900">
                      {parseInt(d.amount)?.toLocaleString()}
                    </td>
                    <td className={`text-gray-900`}>
                      <div className="flex flex-col space-y-0.5">
                        <span className={`text-gray-900 ${cart?.selected?.data?.bonusAllowed === parseInt(d.amount) ? "line-through" : ""}`}>  {parseInt(d.amount)?.toLocaleString()}</span>
                        {cart?.selected?.data?.bonusAllowed === parseInt(d.amount) ? <small>Bonus</small> : ""}
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            )}

            {dataToDisplay?.hasSubscription && (
              <tr className="h-10 w-full">
                <td className="text-gray-900">
                  {dataToDisplay.Subscription?.name}
                </td>
                <td className="text-gray-900">-</td>
                <td className="text-gray-900">
                  {getActivePrice(dataToDisplay?.Subscription?.sub_amount)?.toLocaleString()}
                </td>
                <td className="text-gray-900">
                  {getActivePrice(dataToDisplay?.Subscription?.sub_amount)?.toLocaleString()}
                </td>
              </tr>
            )}
          </tbody>
        </React.Fragment>
      </table>
      <div className="flex flex-col space-y-1 items-end justify-end mt-2">
        <h2 className=" text-gray-800 text-lg font-bold">
          {`Rwf ${dataToDisplay?.hasSubscription ? getActivePrice(dataToDisplay?.Subscription?.sub_amount)?.toLocaleString() : calculator(cart?.selected?.data?.amoutPaid, cart?.selected?.data?.bonusAllowed, "sub")?.toLocaleString()}`}
        </h2>
      </div>
    </>
  );
}
